import React from 'react'
import '../../App.css'
import HeroSection from '../HeroSectionEn'
import Cards from '../CardsEn';
import CardsCert from '../Certificados/CardsCertEn';
import Footer from '../../Footer/FooterEn';
import TimeLine from '../Timeline/TimeLineEn';
import Chrono from '../Chrono/chrono';


function Home () {
    return (
        <div>
            <HeroSection/>
            <Cards/>
            <CardsCert />
            <TimeLine />
            <Footer />
        </div>
    );
}

export default Home;